export default "\n© ASAP - Performance do conhecimento.\n"